import { MODAL_ROUTE } from '@/constants';
import {
    useDeleteSupplierByIdMutation,
    useGetSuppliersQuery,
} from '@/features/slice/suppliers';
import { useModal, useUrlFilter, useUrlPagination } from '@/hooks';

export const useSupplierList = () => {
    const { openModal } = useModal();
    const { page, limit } = useUrlPagination();

    const { sortBy, sortOrder } = useUrlFilter();

    const { data, isLoading, isError, isFetching, error } =
        useGetSuppliersQuery({
            sort_by: sortBy,
            sort_order: sortOrder,
            page,
            limit,
        });

    const [deleteSupplierById, { isLoading: isDeleting }] =
        useDeleteSupplierByIdMutation();

    const handleAddSupplier = () => {
        openModal(MODAL_ROUTE.CREATE_SUPPLIER);
    };

    const handleDeleteSupplier = async (id: string) => {
        deleteSupplierById(id);
    };

    const handleEditSupplier = (id: string) => {
        openModal(MODAL_ROUTE.UPDATE_SUPPLIER, id);
    };

    return {
        data,
        isLoading,
        isError,
        isFetching,
        error,
        handleAddSupplier,

        isDeleting,
        deleteSupplierById,
        handleDeleteSupplier,
        handleEditSupplier,
    };
};
